export default "__VITE_ASSET__ROFBwePR__"